import React, { useState} from "react";
import "./studentLogin.css";
import { db,auth } from "../../firebase";
import { doc, Timestamp,updateDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import Studentnav from "./Studentnav";


const StudentForm = () => {
  const options = [
    {
      label: "",
      value: "",
    },
    {
      label: "BE-1",
      value: "BE-1",
    },
    {
      label: "BE-2",
      value: "BE-2",
    },
    {
      label: "BE-3",
      value: "BE-3",
    },{
      label: "BE-4",
      value: "BE-4",
    },
    {
      label: "BE-5",
      value: "BE-5",
    },{
      label: "BE-6",
      value: "BE-6",
    },{
      label: "BE-7",
      value: "BE-7",
    },{
      label: "BE-8",
      value: "BE-8",
    },{
      label: "BE-9",
      value: "BE-9",
    },{
      label: "BE-10",
      value: "BE-10",
    },{
      label: "BE-11",
      value: "BE-11",
    },
  ];

  const branch = [
    {
      label: "",
      value: "",
    },
    {
      label: "CS",
      value: "CS",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "ENTC",
      value: "ENTC",
    },  
  ];

  const [data, setData] = useState({name: "",email: "",classes: "",department: "",roll:"",cgpa: "",contact: "",error: null,loading: false,
  address:"",misid:"",aboutme:""
});
  const navigate = useNavigate();

  const {name,email,classes,department,roll,cgpa,contact,error,loading,address,misid,aboutme} = data;

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setData({ ...data, error: null, loading: true });
    if (!name || !classes || !department || !roll || !cgpa || !contact || !email || !address || !misid || !aboutme
    ) {
      setData({ ...data, error: "All fields are required" });
    }else{
      try {
     
        await updateDoc(doc(db,'users',auth.currentUser.uid), {
          name,
          email,
          classes,
          department,
          roll,
          cgpa,
          contact,
          createdAt: Timestamp.fromDate(new Date()),
          isOnline: true,
          address,
          misid,
        aboutme
        });
      // })
      setData({name: "",email: "",classes: "",department: "",roll:"",cgpa: "",contact: "",error: null,loading: false,address:"",misid:"",aboutme:""});
      navigate("/stuhome");
    } catch (err) {
      setData({ ...data, error: err.message, loading: false });
    }
    }
   
  };
    

  return(
    <>
      <Studentnav />
      <div id="wrapper">
        <div className="form_div">
          <p className="form_label">Student Details</p>
          <form method="post" action="#" onSubmit={handleSubmit}>
            <p>   <input
              type="text"
              name="name"
              value={name}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Name..."
              required
            /></p>
            <p>
            <input
              type="email"
              name="email"
              value={email}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Email..."
              required
            />
            </p>
            {/* <p>
               <input
              type="text"
              name="classes"
              value={classes}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Class..."
              v-model="signup.user"
              required
            />
            
            </p> */}
            
            
            <p>
              <label className="labelinp">Class</label>
            <select className="form-group w-100 p-2 inp" name="classes" onChange={handleChange}>
            {options.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </select>
            </p>
            <p>
              <label className="labelinp">Department</label>
            <select className="form-group w-100 p-2 inp" name="department" placeholder="Department" onChange={handleChange}>
            {branch.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </select>

            </p>
            <p>  <input
              type="text"
              name="roll"
              value={roll}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Roll Number"
              v-model="signup.user"
              required
            /></p>

{/* <select value={this.state.gender} onChange={this.handleChange}>
        <option name="male"> Male</option>
        <option name="female">Female</option>
      </select> */}
            
            
            {/* <p>
            <input
              type="text"
              name="division"
              value={division}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Division..."
              v-model="signup.user"
              required
            />
            </p> */}
            <p>  <input
              type="text"
              name="misid"
              value={misid}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Micrsoft Teams Id..."
              v-model="signup.user"
              required
            /></p>
            {/* <p>
            <input
              type="text"
              name="department"
              value={department}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Department..."
              v-model="signup.user"
              required
            />
            </p> */}
            <p>
            <input
              type="text"
              name="cgpa"
              value={cgpa}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="CGPA..."
              v-model="signup.user"
              required
            />
            </p>
            <p>
            <input
              type="text"
              name="contact"
              value={contact}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Contact Number..."
              v-model="signup.user"
              required
            />
            </p>
            <p>
            <input
              type="text"
              name="address"
              value={address}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Address..."
              v-model="signup.user"
              required
            />
            </p>
            <p>
            <textarea
              type="text"
              name="aboutme"
              value={aboutme}
              onChange={handleChange}
              className="form-group w-100 p-2 inp"
              placeholder="Bio..."
              v-model="signup.user"
              required
            />
            </p>
            {error ? <p className="error">{error}</p> : null}
            {/* <p><input type="submit" defaultValue="LOGIN" /></p> */}
            <button
              type="submit"
              className="btn w-75 btn-submit pr"
              required
              disabled={loading}
            >
              {loading ? "Submitting in..." : "Submit"}
            </button>
          </form>


        </div>
        <br />
        <br />
        <br />
      </div>
    
    </>
  );
};

export default StudentForm;
